import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../scss/freelance-life.style.scss';
import { InvozioAsFreelancer } from '../components/images/png/icons';
import Header from '../components/header.component';
import { Footer } from '../components/footer.component';
import { FreelanceLifePageLaptop, FreelanceLifePageMan } from '../components/images/png/icons';
import { contentSections } from '../constant/freelance-content.constant';
import FreelancerCtaSection from '../components/freelancer-call-to-action';
import { ContentSection } from '../components/contentsection';
import SectionHeader from '../components/common';
import SEOMetadataComponent from '../components/seo-metadata.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";

export const FreelanceLifePage: React.FC = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
  const canonicalUrl = isEnglish
    ? `https://www.invozio.com/working-as-a-freelancer-and-invoicing-without-tax-registration?lang=${LOCALES.EN_US}`
    : `https://www.invozio.com/att-jobba-som-frilansare-och-fakturera-utan-fskatt?lang=${LOCALES.SV_SE}`;


  const schemaMarkup = getSchemaMarkup("att-jobba-som-frilansare-och-fakturera-utan-fskatt");
  return (
    <>
      <Header />
      <SEOMetadataComponent
        title={t('FREELANCE_LIFE_TITLE')}
        // description={t('FEATURES_MAIN_DESCRIPTION')}
        canonicalUrl={canonicalUrl}
        noindex={false}
        robots="index, follow"
        schemaMarkup={schemaMarkup}
      />
      {/* <SectionHeader
        titleKey={t('FREELANCE_LIFE_TITLE')}
      /> */}
      <SectionHeader
        titleKey={t('FREELANCE_LIFE_TITLE')}
        // subtitleKey={t('FEATURES_PAGE_DESCRIPTION')}
        className="invozio-news-section"
        titleClassName="main-title"
        subtitleClassName="sub-title"
        alignment="center"
      />

      <div className="freelance-life-page">
        {/* Hero Section */}
        <section className="hero-section py-5">
          <Container>
            <Row className="align-items-start">
              <Col lg={6} className='px-0'>
                <h2 className="Heading_h1">
                  {t('WORKING_AS_FREELANCER_INVOICING_WITHOUT_FTAX')}
                </h2>
              </Col>
              <Col lg={6} className='px-0'>
                <div className="hero-description">
                  <p>{t('WORKING_AS_FREELANCER_INTRO_TEXT')}</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Hero Image Section */}
        <section className="hero-image-section">
          <Container>
            <Row>
              <Col className='px-0'>
                <img src={FreelanceLifePageMan} alt="Freelancer working" className="img-fluid image-radius-freelancer" />
              </Col>
            </Row>
          </Container>
        </section>

        {/* Content Sections */}
        {contentSections.map((section, idx) => (
          <ContentSection key={idx} title={t(section.title)}>
            <div className="text-content">
              {section.intro && <p>{t(section.intro)}</p>}
              {section.paragraphs && section.paragraphs.map((p, i) => <p key={i}>{t(p)}</p>)}
              {section.list && (
                <ul className="professions-list">
                  {section.list.map((item, i) => <li key={i}>{t(item)}</li>)}
                </ul>
              )}
              {section.conclusion && section.conclusion.map((c, i) => <p key={i}>{t(c)}</p>)}
            </div>
          </ContentSection>
        ))}

        {/* Content Image Section */}
        <section className="content-image-section py-5">
          <Container>
            <Row>
              <Col className='px-0'>
                <img src={FreelanceLifePageLaptop} alt="Professional working" className="img-fluid image-radius-freelancer" />
              </Col>
            </Row>
          </Container>
        </section>

        <ContentSection title={t('DEMAND_FOR_FREELANCERS_IN_MOST_INDUSTRIES')}>
          <div className="text-content">
            <p>{t('INDUSTRY_DEMAND_TEXT_1')}</p>
            <p>{t('INDUSTRY_DEMAND_TEXT_2')}</p>
            <p>{t('INDUSTRY_DEMAND_TEXT_3')}</p>
            <p>{t('INDUSTRY_DEMAND_TEXT_4')}</p>
          </div>
        </ContentSection>

        <ContentSection title={t('INVOICING_WITHOUT_FTAX_VS_STARTING_COMPANY')}>
          <div className="text-content">
            <p>{t('INVOICING_WITHOUT_FTAX_TEXT_1')}</p>
            <p>{t('INVOICING_WITHOUT_FTAX_TEXT_2')}</p>
          </div>
        </ContentSection>

        <FreelancerCtaSection
          title={t('LET_INVOZIO_HELP_YOU_AS_FREELANCER')}
          description={[t('FREELANCING_REWARDING_CAREER_TEXT_1'), t('FREELANCING_REWARDING_CAREER_TEXT_2')]}
          buttonText={t('CREATE_FREE_ACCOUNT')}
          imageSrc={InvozioAsFreelancer}
          imageAlt="Freelancer illustration"
        />
      </div>

      <Footer />
    </>
  );
};